import { render, staticRenderFns } from "./NavGroupEntry.vue?vue&type=template&id=d39afdd6&scoped=true"
import script from "./NavGroupEntry.vue?vue&type=script&lang=js"
export * from "./NavGroupEntry.vue?vue&type=script&lang=js"
import style0 from "./NavGroupEntry.vue?vue&type=style&index=0&id=d39afdd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39afdd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListGroup,VListItemTitle})
